import React from "react";
import { Outlet } from 'react-router-dom';
import Header from "./header";
import SideNavigation from "./sidenavigation";
import { motion } from "framer-motion";

const PageLayout = ({ children }) => children;

const Layout = () => {     
    return (
        <React.Fragment>
            <div id="main">
                <div className="inner">
                    <Header />
                    <PageLayout>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <Outlet />
                        </motion.div>
                    </PageLayout>
                </div>
            </div>
            <SideNavigation />
        </React.Fragment>
    );
}

export default Layout;